import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BoardsService } from 'src/app/service/boards.service';
import { DialogData } from '../../board.component';
import { StatusComponent } from '../status/status.component';

@Component({
    selector: 'app-late-conf',
    templateUrl: './late-conf.component.html',
    styleUrls: ['./late-conf.component.scss'],
    standalone: false ,  // NOSONAR
})
export class LateConfComponent implements OnInit {

	selectedStatus;
	statusData;
	enableReason: boolean = false;
	selectedReason1;
	selectedReason2;
	selectedReason3;

	// reasonData1;

	reasonData1 = [{ "latereasonID": null, "description": "---" }];


	reasonData2 = [{ "latereasonID": null, "description": "---" }];
	reasonData3 = [{ "latereasonID": null, "description": "---" }];

	enableOther: boolean = false;

	otherData;
	taskName;
	due;

	reasonNumber;
	board_task_id;
	region;

	userid;
	successMessage: string;
	errorMessage: string;
	lateReasonIDFinal: string;

	enableError: boolean = false;
	errormsg;

	params;


	constructor(public dialogRef: MatDialogRef<LateConfComponent>,
		@Inject(MAT_DIALOG_DATA) public dataStore: DialogData, private readonly boardService: BoardsService,
		public dialog: MatDialog) { }

	ngOnInit(): void {
		//dataStore is just a format, whether we call from mytasks or board, the below works just fine, for status change

		this.params = this.dataStore.params;
		this.taskName = this.dataStore.task;
		const dueTemp = this.dataStore.due.split(' ');
		const dueTemp1 = dueTemp[0].split('-');


		this.due = dueTemp1[1] + '/' + dueTemp1[2] + '/' + dueTemp1[0] + ' ' + dueTemp[1].substring(0, 5);
		this.board_task_id = this.dataStore.board_task_id;
		if (this.dataStore.region == 'USER') { // NOSONAR
			this.region = null;
		} else {
			this.region = this.dataStore.region;

		}
		this.userid = this.dataStore.userid;

		this.statusData = [{ "statusID": 'L', "description": "Late" }, { "statusID": 'F', "description": "Forgot To Mark" }];


	}
	onNoClick(): void {
		this.dialogRef.close({ event: "cancel" });
	}

	close(): void {
		this.dialogRef.close({ event: "cancel" });
	}

	statusChange() {


		//Late
		if (this.selectedStatus == 'L') { // NOSONAR
			this.enableReason = true;


			this.boardService.lateconfStatus().subscribe(result => {

				console.info("result", result);

				if (result?.length > 0) {

					const tempArr = [{ "latereasonID": null, "description": "---" }];
					this.reasonData1 = tempArr.concat(result);
				}

				
			});

		}

		//Forgot to Mark
		else {
			this.enableReason = false;
		}

	}

	onReasonDrpDwn1Change() {

		console.info("selected reason 1", this.selectedReason1);

		if (this.selectedReason1 == 'null') { // NOSONAR
			this.reasonData2 = [{ "latereasonID": null, "description": "---" }];
		}

		else {
			this.boardService.changelateconfStatus(this.selectedReason1).subscribe(result => {

				console.info("result", result);

				if (result?.length > 0) {
					const tempArr = [{ "latereasonID": null, "description": "---" }];
					this.reasonData2 = tempArr.concat(result);
				}

				else {

					


					this.reasonData2 = [{ "latereasonID": null, "description": "---" }];

				}

				
			});

		}

		this.reasonData3 = [{ "latereasonID": null, "description": "---" }];


	}

	onReasonDrpDwn2Change() {
		this.boardService.changelateconfStatus(this.selectedReason2).subscribe(result => {

			console.info("result", result);

			if (result?.length > 0) {
				const tempArr = [{ "latereasonID": null, "description": "---" }];
				this.reasonData3 = tempArr.concat(result);
			}

			else {

				


				this.reasonData3 = [{ "latereasonID": null, "description": "---" }];

			}

			
		});

		this.reasonData2.filter(x => x.latereasonID == this.selectedReason2).forEach(element => { // NOSONAR
			if (element.description.toUpperCase() == "OTHER") { // NOSONAR
				this.enableOther = true;
			}
			else {
				this.enableOther = false;
			}

		});


	}

	onReasonDrpDwn3Change() {

		this.reasonData3.filter(x => x.latereasonID == this.selectedReason3).forEach(element => { // NOSONAR
			if (element.description.toUpperCase() == "OTHER") { // NOSONAR
				this.enableOther = true;
			}
			else {
				this.enableOther = false;
			}

		});

	}

	public saveClick() {

		

		//validation
		if (!this.selectedStatus) {
			this.enableError = true;
			this.errormsg = 'Please provide the Status!'
		}

		else if (this.selectedStatus == 'L' && (!this.selectedReason1 || !this.selectedReason2 || this.selectedReason1 == 'null' || this.selectedReason2 == 'null' || this.selectedReason1 == null || this.selectedReason2 == null)) { // NOSONAR

			this.enableError = true;
			this.errormsg = 'At Least Two Levels of Late Reason Codes Must Be Provided!'

		}




		else if (this.enableOther && (!this.otherData || this.otherData == 'null' || this.otherData == null)) { // NOSONAR

			this.enableError = true;
			this.errormsg = 'Other Reason Must Be Provided!'

		}


		else {

			const dialogRef = this.dialog.open(StatusComponent, {
				disableClose: true,
				width: '250px',
				height: '120px',
				data: {
					params: this.params, page: 'late-conf'
				}

			});

			dialogRef.afterClosed().subscribe(result => {
				console.info('The dialog was closed', result);

			});



			// late reason id to be saved logic
			if (this.selectedReason3) {
				this.lateReasonIDFinal = this.selectedReason3;
			}

			else if (this.selectedReason3 == 'null' || !this.selectedReason3 || this.selectedReason3 == null) { // NOSONAR

				this.lateReasonIDFinal = this.selectedReason2;

			}


			// set late reason to 0 -> to hit service
			if (this.selectedStatus == 'F') { // NOSONAR
				this.lateReasonIDFinal = '0';
			}

			if (!this.otherData) {
				this.otherData = 'null';
			}


			

			const dataArr = {
				"intuserID": this.userid,
				"boardTaskID": this.board_task_id,
				"region": this.region,
				"statusID": this.selectedStatus,
				"latereasonID": this.lateReasonIDFinal,
				"other": this.otherData
			};



			console.info("save clicked dataArr", dataArr);

			

			this.boardService.savelateconfStatus(dataArr).subscribe(result => {

				console.info("result", result);

				if (result?.length > 0) {

					// success
					this.successMessage = 'Late Conf Status Set!';

					setTimeout(() => {

						this.dialogRef.close({ event: "Set Late Conf Status - Success" });
						this.successMessage = '';
						this.errorMessage = '';
					}, 1500);

				}

				else {

					//error
					this.errorMessage = 'Error while Set Late Conf Status!';

					setTimeout(() => {

						this.dialogRef.close({ event: "Set Late Conf Status - Failed" });
						this.successMessage = '';
						this.errorMessage = '';
					}, 1500);
				}

				
			});


		}

	}

}